/**
 * Which guest app this is, decided by the address before anything loads.
 *
 *   /<slug>                   a venue's public page: its menu, and ordering ahead
 *   /<slug>/order/<token>     one online order, as it goes from paid to ready
 *   /<slug>/book              booking a table
 *   /<slug>/booking/<token>   one booking, to see or cancel
 *   anything else             the table: a bill or a card, by the URL fragment
 *
 * Each is its own chunk, so a guest scanning a table card downloads nothing
 * of the public page, and the reverse.
 */

const PUBLIC = /^\/([a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9]))(?:\/(order|booking)\/([^/]+)|\/(book))?\/?$/;

const match = PUBLIC.exec(window.location.pathname);
if (match) {
  const { mountPublic } = await import("./public/mount");
  const page = match[2] === "order" ? "order" : match[2] === "booking" ? "booking" : match[4] ? "book" : "menu";
  mountPublic({ slug: match[1]!, page, token: match[3] ? decodeURIComponent(match[3]) : null });
} else {
  await import("./main");
}

export {};
